import React from 'react';

/**
 * Mundalo - Legal/Medical disclaimer.
 *
 * Mandatory banner shown on every page that contains visa, immigration,
 * legal, or healthcare content. Wording is required by Priority 2 of the
 * permanent standing rules.
 *
 * Variants:
 *   variant="legal"   - visa / immigration / general legal
 *   variant="medical" - healthcare / insurance
 *   variant="both"    - combined (default - safest)
 */
const COPY = {
  legal: 'This is general information only, not legal advice. Consult a licensed professional for your specific situation.',
  medical: 'This is general information only, not medical advice. Consult a licensed professional for your specific situation.',
  both: 'This is general information only, not legal advice or medical advice. Consult a licensed professional for your specific situation.',
};

export default function LegalDisclaimer({ variant = 'both', className = '' }) {
  const copy = COPY[variant] || COPY.both;
  return (
    <div
      className={`bg-[#FFF9EC] border-l-4 border-[#E8A830] text-[#0A1F2E]/85 px-4 py-3 my-4 rounded-r font-body text-sm leading-relaxed ${className}`}
      role="note"
      aria-label="Disclaimer"
      data-testid={`legal-disclaimer-${variant}`}
    >
      <span className="font-mono uppercase text-[10px] tracking-[0.18em] text-[#1A5C6E] block mb-1">
        Disclaimer
      </span>
      {copy}
    </div>
  );
}
